import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { Home, Pricing, AboutUs, Legal, Terms } from './pages';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/Tarifs' element={<Pricing />} />
          <Route path='/Qui-sommes-nous' element={<AboutUs />} />
          <Route path='/Mentions' element={<Legal />} />
          <Route path='/Conditions' element={<Terms />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
